import { render, staticRenderFns } from "./addressBookEditModal.vue?vue&type=template&id=1deb0e88&scoped=true&"
import script from "./addressBookEditModal.vue?vue&type=script&lang=js&"
export * from "./addressBookEditModal.vue?vue&type=script&lang=js&"
import style0 from "./addressBookEditModal.vue?vue&type=style&index=0&id=1deb0e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb0e88",
  null
  
)

export default component.exports